<div>
  <div style="margin-left: 80%; margin-bottom: 2%;">
    <button
      id="print-button"
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%; display: none;"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      [useExistingCss]="true"
      ngxPrint
    >
      Print
    </button>

    <button
      (click)="print()"
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%"
      mat-raised-button
      color="primary"
    >
      Print
    </button>

    <button
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%"
      (click)="exportExcel('issue_seller_Invoice_Register')"
      mat-raised-button
      color="primary"
    >
      Export
    </button>

    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <!-- Office Representative Briefly Report -->
  <div *ngIf="type == 'Off_Represantative Briefly'" id="print-section" style="margin: 20px;">
  <table class="table table-bordered" style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr style="background-color: white;">
        <th colspan="3" style="border: 1px solid #000; padding: 6px;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
        <th colspan="2" style="border: 1px solid #000; padding: 6px;">अंकाचे नाव : {{ newissuedatepp }}</th>
        <th colspan="2" style="border: 1px solid #000; padding: 6px;">Off. Representative Briefly</th>
        <th colspan="2" style="border: 1px solid #000; padding: 6px;">अंकाचे कॅटेगरी : {{ issue_cat }}</th>
        <th colspan="2" style="border: 1px solid #000; padding: 6px;">
          Date: From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}
        </th>
        <th colspan="1" style="border: 1px solid #000; padding: 6px;">दिनांक: {{ today1 | date: 'dd-MM-yyyy' }}</th>
        <th colspan="2" style="border: 1px solid #000; padding: 6px;">पृष्ठ क्र: 1</th>
      </tr>
      <tr style="background-color: #f0f0f0;">
        <th style="border: 1px solid #000; padding: 6px;">Sr</th>
        <th style="border: 1px solid #000; padding: 6px;">Booking Date</th>
        <th style="border: 1px solid #000; padding: 6px;">Booking No</th>
        <th style="border: 1px solid #000; padding: 6px;">Issue Seller Name</th>
        <th style="border: 1px solid #000; padding: 6px;">Representative</th>
        <th style="border: 1px solid #000; padding: 6px;">Rep Mobile</th>
        <th style="border: 1px solid #000; padding: 6px;">Office Rep</th>
        <th style="border: 1px solid #000; padding: 6px;">Issue Amt</th>
        <th style="border: 1px solid #000; padding: 6px;">Issue Copies</th>
        <th style="border: 1px solid #000; padding: 6px;">Total Amt</th>
        <th style="border: 1px solid #000; padding: 6px;">Discount</th>
        <th style="border: 1px solid #000; padding: 6px;">Net Amt</th>
        <th style="border: 1px solid #000; padding: 6px;">Received Amt</th>
        <th style="border: 1px solid #000; padding: 6px;">Pending Amt</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let report of filteredinDetailsRegReport; let reportIndex = index">
        <!-- Group Header -->
        <tr style="font-weight: bold; background-color:  #e8f0ff;">
          <td colspan="14" style="border: 1px solid #000; padding: 8px;">
            Group Sr: {{ reportIndex + 1 }} - {{ report.off_rep_name }}
          </td>
        </tr>

        <!-- Item Rows -->
        <tr *ngFor="let item of report.advt_data; let itemIndex = index">
          <td style="border: 1px solid #000; padding: 6px;">{{ itemIndex + 1 }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.booking_date }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.booking_no }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.issue_seller_name }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.rep_name }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.rep_mob_no }}</td>
          <td style="border: 1px solid #000; padding: 6px;">{{ item.off_rep_name }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.issue_amt }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.issue_copies }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.total_amt }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.disc_amt }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.amount }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.total_amt - item.remaingamt }}</td>
          <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.remaingamt }}</td>
        </tr>

        <!-- Group Totals -->
        <tr style="font-weight: bold; background-color: white;">
          <td colspan="7" style="border: 1px solid #000; text-align: right; padding: 6px;">Group Total</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_price_total | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_copies_total | number }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_issue_amt_total | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_discount_total | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_net_amt_total | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_received_total | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ report.group_remaining_total | number: '1.2-2' }}</td>
        </tr>
      </ng-container>
    </tbody>

    <!-- Grand Totals -->
    <tfoot>
      <tr style="font-weight: bold; background-color: #d9ead3;">
        <td colspan="7" style="border: 1px solid #000; text-align: right; padding: 6px;">Grand Total</td>
        <td style="border: 1px solid #000; text-align: right;">{{ price | number: '1.2-2' }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ issueCopies | number }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ issue_amt | number: '1.2-2' }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ discount | number: '1.2-2' }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ netamount | number: '1.2-2' }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ recivedamt | number: '1.2-2' }}</td>
        <td style="border: 1px solid #000; text-align: right;">{{ remainingamt | number: '1.2-2' }}</td>
      </tr>
    </tfoot>
  </table>
</div>


  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>
</div>
